import { createSelector } from 'reselect';
import { addDropDownReviewSectionSelector } from 'selectors/testTarget/offers/addDropDownReviewSection/addDropDownReviewSectionSelector';

const showSelector = createSelector(addDropDownReviewSectionSelector, addDropDownReviewSection => !!addDropDownReviewSection.show);

export { showSelector };
